import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/department";

export type createType = {};

export class OrganizationApi extends BaseAPI {
  static tree(query: { keyword: string }): Promise<any> {
    return this.api.get(`${path}-tree`, { params: { ...query } });
  }
  static list(query: { keyword?: string }): Promise<AxiosResponse> {
    return this.api.get(`${path}-list`, { params: { ...query } });
  }
  static detail( id: number): Promise<any> {
    return this.api.get(`departments/${id}`);
  }
  static create(form: any): Promise<any> {
    return this.api.post(`departments`, form);
  }
  static update(form: any, id: number): Promise<any> {
    return this.api.patch(`departments/${id}`, form);
  }
  static delete(id: number): Promise<any> {
    return this.api.delete(`departments/${id}`);
  }
  static updateEmployees(id: number, id_employee:number, body:any): Promise<any> {
    return this.api.patch(`departments/${id}/employees/${id_employee}`, body);
  }
  static deleteEmployees(id: number, id_employee:number): Promise<any> {
    return this.api.delete(`departments/${id}/employees/${id_employee}`);
  }
}
